// Libraries
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
// Services
import { ApiService, SettingService } from '../../common/modules/core/services';

@Injectable()
export class LocalService {
    // Api Domain Url
    private apiUrl = '';
    
    constructor(
        private apiService: ApiService,
        private settingService: SettingService
    ) {
        // Get API service domain for communate.
        this.apiUrl = this.settingService.getSetting('api_service_domain');
    }
    
    getLocalNetWork() {
        const requestUrl = '/auth/negotiate';
        return this.apiService.get<any>(requestUrl);
    }
}


// WEBPACK FOOTER //
// ./src/holiday/services/LocalService.ts